/* Neko Toys — How to Play (Direction B: Kuji Ticket Stub)
   Just one behavior: step-5 demo button toggles sealed → revealed images
   inside that ticket's phone screen. No scroll tracking (Direction B
   doesn't need a global active-step indicator). */
(function () {
  'use strict';

  document.querySelectorAll('[data-htp-demo-toggle]').forEach(function (btn) {
    let revealed = false;
    const ticket = btn.closest('.htpb-ticket');
    if (!ticket) return;

    const labelSealed = btn.querySelector('[data-demo-label-sealed]');
    const labelRevealed = btn.querySelector('[data-demo-label-revealed]');

    btn.addEventListener('click', function () {
      revealed = !revealed;
      const target = revealed ? 'revealed' : 'sealed';

      ticket.querySelectorAll('[data-demo-state]').forEach(function (el) {
        el.classList.toggle('is-active', el.dataset.demoState === target);
      });

      if (labelSealed) labelSealed.toggleAttribute('hidden', revealed);
      if (labelRevealed) labelRevealed.toggleAttribute('hidden', !revealed);
    });
  });
})();
